import React from 'react';
import PropTypes from 'prop-types';

import { FlexRow } from 'ui-components/components/flex';
import InsuranceOptionContainer from '../../../../fulfillment-planner/insurance-option/container';
import InsuranceOptionLabel from '../../../../fulfillment-planner/insurance-option/label';
import InsuredAmountContainer from '../../../../fulfillment-planner/insured-amount/container';
import InsuredAmountLabel from '../../../../fulfillment-planner/insured-amount/label';
import { useFulfillmentPlannerContext } from '../../../../fulfillment-planner/context';
import { useEnableInsurancePromoExperiment } from '../../../../feature-flags/hooks/use-enable-insurance-promo-experiment';
import { InsurancePromo } from '../../../../fulfillment-planner/insurance-promo/insurance-promo';

import style from '../style.module.less';

const renderInsuredAmount = (fulfillmentPlanId) => {
  return (
    <React.Fragment>
      <div className={style.label}>
        <InsuredAmountLabel />
      </div>
      <InsuredAmountContainer className={style['insurance-amount']} fulfillmentPlanId={fulfillmentPlanId} />
      <div />
    </React.Fragment>
  );
};

const InsuranceFieldsInPromo = ({ fulfillmentPlanId }) => {
  const { hasInsuranceProviderSelected } = useFulfillmentPlannerContext();

  return (
    <div>
      <FlexRow className={style['insurance-row-in-promo']}>
        <div className={style['insurance-label-in-promo']}>
          <InsuranceOptionLabel />
        </div>
        <div className={style['insurance-input-in-promo']}>
          <InsuranceOptionContainer fulfillmentPlanId={fulfillmentPlanId} isPartOfInsurancePromoExperiment />
        </div>
      </FlexRow>
      {hasInsuranceProviderSelected && (
        <FlexRow className={style['insurance-row-in-promo']}>
          <div className={style['insurance-label-in-promo']}>
            <InsuredAmountLabel />
          </div>
          <InsuredAmountContainer
            className={style['insurance-amount']}
            fulfillmentPlanId={fulfillmentPlanId}
            rowClassName={style['insurance-input-in-promo']}
          />
        </FlexRow>
      )}
    </div>
  );
};

const Insurance = ({ fulfillmentPlanId }) => {
  const { hasInsuranceProviderSelected } = useFulfillmentPlannerContext();
  const isInsurancePromoExperimentEnabled = useEnableInsurancePromoExperiment();

  if (isInsurancePromoExperimentEnabled) {
    return (
      <InsurancePromo className={style['insurance-promo']} headerClassName={style['insurance-promo-header']}>
        <InsuranceFieldsInPromo fulfillmentPlanId={fulfillmentPlanId} />
      </InsurancePromo>
    );
  }

  return (
    <React.Fragment>
      <div className={style.label}>
        <InsuranceOptionLabel />
      </div>
      <InsuranceOptionContainer className={style['insurance-option']} fulfillmentPlanId={fulfillmentPlanId} />
      <div />
      {hasInsuranceProviderSelected && renderInsuredAmount(fulfillmentPlanId)}
    </React.Fragment>
  );
};

Insurance.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

export default React.memo(Insurance);
